<template>
  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
  <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
</template>
